import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Bushireforschoolpicnininpune() {



const cardData =
{
  keyword: 'Bus Hire for School Picnic in Pune',
  heading: 'Sanavi Travels: Bus Hire for School Picnic in Pune',
  headingDescription: 'Sanavi Travels offers safe, reliable, and well-organized bus hire services for school picnics in Pune, ensuring comfortable group travel for students, teachers, and parents with trained drivers and well-maintained buses.',

  top: 'Top Benefits of Choosing Bus Hire for School Picnic in Pune',

  topPlaces: [
    {
      title: 'Safe Transportation for Students',
      description: 'Bus hire for school picnic in Pune focuses primarily on student safety and discipline during travel. Dedicated school picnic buses are operated by experienced drivers who understand the responsibility of transporting children. These buses follow planned routes, maintain steady speeds, and ensure smooth driving to avoid discomfort or risk. Spacious seating allows students to sit comfortably without overcrowding, while proper ventilation and optional air-conditioning keep the environment pleasant throughout the journey. Teachers and staff can easily supervise students inside a single bus, maintaining order and safety at all times. This makes school picnic travel structured, controlled, and far safer than multiple small vehicles.'
    },
    {
      title: 'Comfortable Group Travel Experience',
      description: 'School picnics involve long hours of travel, excitement, and energy, making comfort an important factor. Hiring a bus ensures that students can travel together in a relaxed and comfortable environment. Push-back seating, wide aisles, and smooth suspension help reduce travel fatigue, especially for younger children. Students can enjoy the journey with their friends, sing songs, and participate in group activities while remaining seated safely. Teachers and parents appreciate the ease of managing a large group without repeated stops or confusion.'
    },
    {
      title: 'Ideal for Educational Trips & Excursions',
      description: 'Beyond picnics, school buses are ideal for educational excursions, nature visits, museums, and sightseeing tours around Pune and nearby locations. A single bus keeps the group united, ensures timely arrivals, and helps schools stick to planned schedules. Students gain a sense of discipline and responsibility while traveling as a group, which adds educational value to the outing.'
    },
    {
      title: 'Convenient for Teachers & Staff',
      description: 'Managing students during a picnic can be challenging, especially when transportation is unorganized. Bus hire simplifies this by allowing teachers and staff to monitor attendance, manage seating, and maintain discipline throughout the journey. Boarding and deboarding become smooth, saving time and reducing stress. Staff can focus more on student supervision and less on travel coordination.'
    },
    {
      title: 'Cost-Effective Group Transportation',
      description: 'Hiring a bus for a school picnic is a cost-effective solution compared to arranging multiple smaller vehicles. It reduces fuel expenses, toll costs, and coordination issues while providing a structured travel plan. Schools and parents benefit from predictable pricing and shared transportation costs.'
    },
    {
      title: 'Suitable for Short & Long Distance Trips',
      description: 'Whether the picnic destination is within Pune city or an outstation location, buses are suitable for both short and long-distance travel. Their stability on highways and city roads ensures a smooth ride regardless of distance.'
    },
    {
      title: 'Hygienic & Well-Maintained Vehicles',
      description: 'Cleanliness and hygiene are crucial for school travel. Picnic buses are thoroughly cleaned and inspected before trips, ensuring a healthy environment for children. Regular maintenance checks help prevent breakdowns and delays.'
    },
    {
      title: 'Flexible Seating Capacity',
      description: 'With options like mini buses, 32 seater, and 35 seater buses, schools can choose vehicles based on the number of students and staff. This flexibility ensures proper seating without overcrowding.'
    },
    {
      title: 'Reliable Scheduling & Timely Travel',
      description: 'Bus hire services operate on planned schedules, ensuring on-time pickup and drop-off. This helps schools manage time efficiently and avoid delays that could disrupt picnic plans.'
    },
    {
      title: 'Peace of Mind for Parents',
      description: 'Parents feel reassured knowing their children are traveling together in a safe, supervised, and professionally managed bus. This trust factor is a key advantage of organized bus hire for school picnics.'
    }
  ],

  services: [
    {
      name: 'Bus Hire for School Picnic in Pune',
      description: 'Sanavi Travels provides dedicated bus hire services for school picnics in Pune, designed to ensure maximum safety, comfort, and organization for students and staff. Our buses are spacious, well-maintained, and driven by experienced professionals who understand the responsibility of student transportation. The service supports short city trips as well as outstation picnics, offering a structured travel experience that keeps students together, on schedule, and under proper supervision throughout the journey.'
    },
    {
      name: 'AC Bus for School Picnic Pune',
      description: 'AC buses offer a cool and comfortable environment for students, especially during summer picnics, helping them stay relaxed and energetic throughout the trip.'
    },
    {
      name: 'Non AC Bus Hire School Picnic Pune',
      description: 'Non-AC buses provide a budget-friendly option while still maintaining safety, space, and comfort for school picnic travel.'
    },
    {
      name: '32 Seater Bus School Picnic Pune',
      description: '32 seater buses are ideal for medium-sized student groups, ensuring proper seating and easy supervision by teachers.'
    },
    {
      name: '35 Seater Bus Hire School Picnic Pune',
      description: '35 seater buses are suitable for larger school groups, offering ample seating and smooth travel for longer distances.'
    },
    {
      name: 'Mini Bus on Rent School Picnic Pune',
      description: 'Mini buses are perfect for smaller classes or short-distance picnics, providing compact yet comfortable travel.'
    },
    {
      name: 'Bus for Students School Picnic Pune',
      description: 'Specially arranged buses ensure students travel together safely under adult supervision.'
    },
    {
      name: 'Affordable Bus Rental School Picnic Pune',
      description: 'Affordable pricing helps schools and parents manage picnic transportation costs without compromising safety.'
    },
    {
      name: 'Best Bus Service School Picnic Pune',
      description: 'Sanavi Travels is trusted for reliable service, disciplined drivers, and student-friendly travel arrangements.'
    },
    {
      name: 'Bus with Driver School Picnic Pune',
      description: 'Professional drivers ensure safe driving, punctual schedules, and smooth coordination throughout the trip.'
    },
    {
      name: 'Outstation Bus School Picnic Pune',
      description: 'Outstation bus services support longer picnic trips to destinations outside Pune with comfort and reliability.'
    }
  ],

  tableData: [
    ['AC Bus', 'Non AC Bus'],
    ['32 Seater', '35 Seater'],
    ['Mini Bus', 'Student Groups'],
    ['Local Picnic', 'Outstation Picnic'],
    ['Safe Travel', 'Professional Drivers']
  ],

  whychoose: [
    {
      WhyChooseheading: 'Student Safety First',
      WhyChoosedescription: 'Our school picnic bus services prioritize student safety through experienced drivers, controlled speeds, and organized seating, ensuring a secure journey from start to finish.'
    },
    {
      WhyChooseheading: 'Comfortable Group Travel',
      WhyChoosedescription: 'Spacious seating and smooth rides keep students comfortable and energetic throughout the picnic journey.'
    },
    {
      WhyChooseheading: 'Reliable & Punctual Service',
      WhyChoosedescription: 'Timely pickups and drops help schools follow planned schedules without delays.'
    },
    {
      WhyChooseheading: 'Cost-Effective Transportation',
      WhyChoosedescription: 'Group bus hire reduces overall travel costs while maintaining quality and safety.'
    },
    {
      WhyChooseheading: 'Experienced Drivers',
      WhyChoosedescription: 'Professional drivers ensure disciplined and careful driving suitable for student travel.'
    },
    {
      WhyChooseheading: 'Well-Maintained Buses',
      WhyChoosedescription: 'Regular maintenance and cleaning ensure a hygienic and dependable travel environment.'
    },
    {
      WhyChooseheading: 'Flexible Seating Options',
      WhyChoosedescription: 'Multiple seating capacities allow schools to choose the right bus for their group size.'
    },
    {
      WhyChooseheading: 'Trusted by Schools',
      WhyChoosedescription: 'Sanavi Travels is trusted by schools for organized, safe, and smooth picnic transportation.'
    }
  ]
};

const faqData = [
  {
    question: 'Do you provide bus hire services for school picnics in Pune?',
    answer: 'Yes, Sanavi Travels offers dedicated bus hire services for school picnics in Pune with a strong focus on student safety and comfort.'
  },
  {
    question: 'Are AC buses available for school picnics?',
    answer: 'Yes, both AC and Non-AC buses are available based on school preferences and budget.'
  },
  {
    question: 'What seating capacities are available?',
    answer: 'We provide mini buses, 32 seater, and 35 seater buses suitable for school picnic groups.'
  },
  {
    question: 'Are drivers experienced in handling school trips?',
    answer: 'Yes, our drivers are trained and experienced in managing student transportation responsibly.'
  },
  {
    question: 'Can buses be hired for outstation school picnics?',
    answer: 'Yes, we offer reliable outstation bus services for school picnic destinations.'
  },
  {
    question: 'Are buses cleaned before trips?',
    answer: 'Yes, all buses are cleaned and inspected before every school picnic journey.'
  },
  {
    question: 'Is pricing affordable for schools?',
    answer: 'Yes, we offer cost-effective and transparent pricing suitable for school groups.'
  },
  {
    question: 'Can pickup and drop points be customized?',
    answer: 'Yes, pickup and drop locations can be planned as per school requirements.'
  },
  {
    question: 'Is supervision easy for teachers?',
    answer: 'Yes, traveling in a single bus makes supervision and attendance management easier for teachers.'
  },
  {
    question: 'Is customer support available?',
    answer: 'Yes, 24/7 customer support is available for all school picnic bookings.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mrs. Sunita Kulkarni',
    feedback: 'Our school hired a bus from Sanavi Travels for a picnic in Pune. The bus was clean, the driver was very patient with children, and the entire trip was well organized. Parents and teachers were very satisfied.',
    rating: 5
  },
  {
    id: 2,
    name: 'Mr. Ramesh Patil',
    feedback: 'Sanavi Travels managed our school picnic transportation perfectly. Students were comfortable, the schedule was maintained, and safety was clearly a priority. Highly recommended.',
    rating: 5
  }
];












































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];








const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Bus Hire for School Picnic in Pune - Sanavi Travels",
  "description": "Sanavi Travels offers bus hire services in Pune for school picnics. Choose AC or Non AC buses, 32 or 35 seater options, or mini buses on rent. Perfect for students, family trips, group outings, weddings, sightseeing, and outstation journeys with professional drivers at affordable rates.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "2000+"
  }
};








  return (
    <div>

<Helmet>
  <title>
    Call : +91 7387507373 | Bus Hire for School Picnic in Pune | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Hire buses in Pune for school picnics with Sanavi Travels. AC/Non AC, 32/35 seater, or mini buses for students, family, group outings, weddings, sightseeing, and outstation trips with professional driver at affordable rates."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>

      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/313.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Bushireforschoolpicnininpune;